export const DEFAULT_COMPANY_LOGO = '/images/default_company_logo.jpg';

export const applyLogoFallback = (image: HTMLImageElement) => {
  if (image.getAttribute('src') !== DEFAULT_COMPANY_LOGO) image.src = DEFAULT_COMPANY_LOGO;
};
